<template>
	<div>

		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.payment_methods }}
							</h6>
							<div class="element-box-tp">

								<div v-if="status > 0">
									<div class="alert alert-danger" v-if="status == 403">
										{{ t.error.access_denied_content }}
									</div>
									<div class="alert alert-danger" v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</div>
								</div>
								<table-component
										v-if="status == 200"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="payments"
								>
									<template>
										<table-column>
											<template slot-scope="row">
												<router-link :to="{ query: {id: row.id} }" v-if="row.name">
													{{ row.name }}
												</router-link>
											</template>
										</table-column>
										<table-column cell-class="w50">
											<template slot-scope="row">
												<span v-if="row.is_active">
														<i class="icon-check"></i>
												</span>
												<span v-else>
														<i class="icon-close"></i>
												</span>
											</template>
										</table-column>
                    <table-column cell-class="w50">
                      <template slot-scope="row">
                        <router-link :to="{ query: {accountId: row.id} }" v-if="row.name">
                          <i class="os-icon os-icon-layers"></i>
                        </router-link>
                      </template>
                    </table-column>
									</template>
								</table-component>

							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<userWidget :collapsed="true" :title="t.user.last_login" :filter="{ per_page: 10, short: 'lastLogin', direction: 'desc', loginDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss')}}" />
					<userWidget :collapsed="true" :title="t.last_activity" :filter="{ per_page:10, short: 'lastActivityAt', direction: 'desc', activityDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss') } }" />
				</div>
			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="umodal" v-on:close="closeModal">

      <generalForm v-if="$route.query.id" />

		</sweet-modal>

    <sweet-modal ref="account" v-on:close="closeModal" width="1060">

      <paymentAccounts :id="$route.query.accountId" v-if="$route.query.accountId > 0" />

    </sweet-modal>

  </div>
</template>

<script>
    import paymentAccounts from '@/components/payment/paymentAccounts'
    import generalForm from '@/components/payment/form/paymentMethod'
    import userWidget from '@/components/user/widget/userWidget'
    import { TableComponent, TableColumn } from 'vue-table-component'
    export default {
        components:{ TableComponent, TableColumn, generalForm, userWidget, paymentAccounts},
        name: 'paymentList',
        data () {
            return {
                t: this.$root.t,
                payments: null,
	            status: 0
            }
        },
	    watch: {
            '$route.query.id' () {
                this.openModal()
            },
          '$route.query.accountId' () {
              this.openAccountModal()
          }
	    },
	    mounted () {
			    this.fetchPayments()
	    },
	    methods: {
            closeModal () {
                this.$route.query.id = null;
                this.$router.push({});

                setTimeout(() => {
                    document.body.style.overflow='auto';
                }, 500);
            },
            openAccountModal () {
                this.$refs.account.open();
            },
            openModal () {
                this.$refs.umodal.open();
            },
            fetchPayments () {
                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/payment/methods',
                        { params: this.$route.query }).then(response => {

                        this.pagination = response.body.result.pagination;
                        this.payments =  Object.values(response.body.result.payments);
                        this.status = response.status;

                        this.isLoading = false;
	                }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })
                }
            },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/payment/list.vue